export default __webpack_public_path__ + "static/sg-f7ec643ef1b348a7450f61f5ba8757c7.svg";